module.exports = __webpack_public_path__ + "static/img/1.AI报账_悬浮窗_image@2x.5d7199b4.png";